import posthog from "posthog-js";

export const LABOR_CERTIFICATE = {
  label: "Certificado laboral",
  content: "Justificativo:\nTratamiento:\nDías de reposo:",
};

const LABOR_CERTIFICATE_EVENTS = {
  BUTTON_CLICK: "labor_certificate:button_click",
};

export const captureLaborCertificateClick = (tab) => {
  posthog.capture(LABOR_CERTIFICATE_EVENTS.BUTTON_CLICK, { tab });
};
